const UK_TIME_ZONE = 'Europe/London';

const ukDateFormatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: UK_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

const ukDateTimeFormatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: UK_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
});

function asDate(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value?.toDate === 'function') {
    const parsed = value.toDate();
    return parsed instanceof Date && !Number.isNaN(parsed.getTime()) ? parsed : null;
  }
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function partsToObject(parts = []) {
  return parts.reduce((acc, part) => {
    if (part.type !== 'literal') acc[part.type] = part.value;
    return acc;
  }, {});
}

function padNumber(value) {
  return String(value).padStart(2, '0');
}

function parseDateISO(dateIso) {
  if (typeof dateIso !== 'string' || dateIso.trim() === '') return null;
  const [year, month, day] = dateIso.trim().split('-').map(Number);
  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) return null;
  return { year, month, day };
}

function parseHHMM(value = '') {
  const [hour, minute] = String(value).split(':').map(Number);
  return {
    hour: Number.isFinite(hour) ? hour : 0,
    minute: Number.isFinite(minute) ? minute : 0,
  };
}

function getUKOffsetMs(date) {
  const parts = partsToObject(ukDateTimeFormatter.formatToParts(date));
  const wallClockUtc = Date.UTC(
    Number(parts.year),
    Number(parts.month) - 1,
    Number(parts.day),
    Number(parts.hour),
    Number(parts.minute),
    Number(parts.second),
    0
  );
  return wallClockUtc - date.getTime();
}

export function formatUKDateISO(value) {
  const date = asDate(value);
  if (!date) return '';
  const parts = partsToObject(ukDateFormatter.formatToParts(date));
  if (!parts.year || !parts.month || !parts.day) return '';
  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function todayUKDateISO() {
  return formatUKDateISO(new Date());
}

export function addDaysToDateISO(dateIso, days) {
  const parsed = parseDateISO(dateIso);
  if (!parsed) return '';
  const next = new Date(Date.UTC(parsed.year, parsed.month - 1, parsed.day, 0, 0, 0, 0));
  next.setUTCDate(next.getUTCDate() + Number(days || 0));
  return `${next.getUTCFullYear()}-${padNumber(next.getUTCMonth() + 1)}-${padNumber(next.getUTCDate())}`;
}

export function ukDateISOToUTCStart(dateIso) {
  const parsed = parseDateISO(dateIso);
  if (!parsed) return null;
  const utcMidnight = new Date(Date.UTC(parsed.year, parsed.month - 1, parsed.day, 0, 0, 0, 0));
  const offsetMs = getUKOffsetMs(utcMidnight);
  return new Date(Date.UTC(parsed.year, parsed.month - 1, parsed.day, 0, 0, 0, 0) - offsetMs);
}

export function ukDateISOToUTCEnd(dateIso) {
  const nextStart = ukDateISOToUTCStart(addDaysToDateISO(dateIso, 1));
  return nextStart ? new Date(nextStart.getTime() - 1) : null;
}

export function ukDateISOToLocalDate(dateIso, hhmm = '00:00') {
  const parsed = parseDateISO(dateIso);
  if (!parsed) return null;
  const time = parseHHMM(hhmm);
  return new Date(parsed.year, parsed.month - 1, parsed.day, time.hour, time.minute, 0, 0);
}

export function formatLocalDateISO(value) {
  const date = asDate(value);
  if (!date) return '';
  return `${date.getFullYear()}-${padNumber(date.getMonth() + 1)}-${padNumber(date.getDate())}`;
}

export function formatUKDateLabel(dateIso, options = { day: '2-digit', month: 'short' }) {
  const date = ukDateISOToUTCStart(dateIso);
  if (!date) return dateIso || '';
  return date.toLocaleDateString('en-GB', {
    ...options,
    timeZone: UK_TIME_ZONE,
  });
}
